import { formatNumberWithCommas } from '@/lib/utils/formatNumberWithCommas';
import { C_DECIMAL_PLACES } from '@/ts/constants/C_DECIMAL_PLACES';

import type { T_Pool } from '@/ts/types/T_Pool';

export function calculatePoolMetrics(pool: T_Pool) {
  // Calculate Total Pool Volume = totalSupply * presaleTokenPriceInUSDC
  const totalPoolVolume = (() => {
    const totalSupply = parseFloat(pool.totalSupply || '0');
    const presaleTokenPrice = parseFloat(pool.presaleTokenPriceInUSDC || '0');
    const volume = totalSupply * presaleTokenPrice;
    return `$${formatNumberWithCommas(volume, 2)}`;
  })();

  // Calculate Total Pool Tokens = totalSupply
  const totalPoolTokens = formatNumberWithCommas(pool.totalSupply || '0');

  // Calculate Available Tokens percentage and count
  const { availableTokensPercentage, availableTokensCount } = (() => {
    const totalSupply = parseFloat(pool.totalSupply || '0');
    const totalSoldTokens = parseFloat(
      pool.blockchainData?.totalSoldTokensDecimal || '0'
    );
    const totalBoughtBackTokensDecimal = parseFloat(
      pool.blockchainData?.totalBoughtBackTokensDecimal || '0'
    );

    if (!totalSupply || totalSupply === 0) {
      return { availableTokensPercentage: 0, availableTokensCount: '0' };
    }

    const available =
      totalSupply - (totalSoldTokens - totalBoughtBackTokensDecimal);
    const percentage = (available / totalSupply) * 100;
    const formattedCount = formatNumberWithCommas(available);

    return {
      availableTokensPercentage: Math.max(
        0,
        Math.min(100, parseFloat(percentage.toFixed(C_DECIMAL_PLACES)))
      ),
      availableTokensCount: formattedCount
    };
  })();

  return {
    totalPoolVolume,
    totalPoolTokens,
    availableTokensPercentage,
    availableTokensCount
  };
}
